import { useTranslation } from 'react-i18next';
import Alert from '@/storybook/components/Alert/Alert';
import Text from '@/storybook/components/Text/Text';
import styles from './DEPersonifyComplianceDisclaimer.module.css';

const DEPersonifyComplianceDisclaimer = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'header.DEComplianceDisclaimer' });

  return (
    <Alert message={t('title')} variant="warning">
      <Text as="p" className={styles.para}>
        {t('paragraph1')}
      </Text>
      <Text as="p" className={styles.para}>
        {t('paragraph2')}
      </Text>
      <ul className={styles.disclaimerList}>
        <li>{t('bulletOffLabelBackgroundInfo')}</li>
        <li>{t('bulletMedicalHybridRoles')}</li>
      </ul>
    </Alert>
  );
};

export default DEPersonifyComplianceDisclaimer;
